import { Directive } from '@angular/core';

// Marks every datepicker input so styles.scss can give it the calendar cue: Nebular's
// directive adds no class, and [nbDatepicker] is a binding, not an attribute in the DOM.
@Directive({
  standalone: false,
  selector: 'input[nbDatepicker]',
  host: {class: 'date-field'},
})
export class DateFieldDirective {}
